<template>
  <div class="mobileBottomCtn">
    <div class="title">资源循环，变废为宝！</div>
    <div class="menuCtn">
      <div class="menuLine">
        <div class="menu" @click="goUrl('/mobile/home')">网站首页</div>
        <div class="menu" @click="goUrl('/mobile/news')">新闻中心</div>
        <div class="menu" @click="goUrl('/mobile/about')">关于我们</div>
      </div>
      <div class="menuLine">
        <div class="menu" @click="goUrl('/mobile/anli')">项目案例</div>
        <div class="menu" @click="goUrl('/mobile/fuwu')">投资者关系</div>
        <div class="menu" @click="goUrl('/mobile/contact')">联系我们</div>
      </div>
    </div>
    <!-- <el-menu class="el-menu-vertical-demo" router background-color="#fff" text-color="#000b12" mode="horizontal">
      <el-menu-item index="/mobile/home">
        <template slot="title">
          <div class="label">网站首页</div>
        </template>
      </el-menu-item>
      <el-menu-item index="/mobile/news">
        <template slot="title">
          <div class="label">新闻中心</div>
        </template>
      </el-menu-item>
      <el-menu-item index="/mobile/about">
        <template slot="title">
          <div class="label">关于我们</div>
        </template>
      </el-menu-item>
      <el-menu-item index="/mobile/contact">
        <template slot="title">
          <div class="label">联系我们</div>
        </template>
      </el-menu-item>
      <el-menu-item index="/mobile/anli">
        <template slot="title">
          <div class="label">项目案例</div>
        </template>
      </el-menu-item>
      <el-menu-item index="/mobile/fuwu">
        <template slot="title">
          <div class="label">投资者关系</div>
        </template>
      </el-menu-item>
    </el-menu> -->
    <div class="content">服务热线：0571-85371190</div>
    <div class="icp">
      <img :src="require('@/assets/images/logo01.dd7ff50e.png')" />
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备2025166447号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mobilebottom',
  methods: {
    goUrl(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobileBottomCtn {
  // background: #fff;

  .title {
    line-height: 60px;
    font-size: 22px;
    color: #117149;
    padding: 0 20px;
    font-weight: bold;
    text-align: center;
  }

  .content {
    color: #000b12;
    line-height: 26px;
    margin: 12px 0;
    padding: 0 20px;
    text-align: center;
  }

  .menuCtn {
    padding: 0 20px;
    color: #000b12;

    .menuLine {
      display: flex;
      justify-content: space-between;
      margin: 16px 0;

      .menu {
        flex: 1;
        text-align: center;
        line-height: 26px;
      }
    }
  }

  .icp {
    text-align: center;
    padding: 20px 0;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      color: #000b12 !important;
      text-decoration: none;
    }

    img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
}
</style>